import { Injectable } from '@angular/core';
import {
	HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpHeaders, HttpErrorResponse
} from '@angular/common/http';

import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable, observable, Subject, throwError } from 'rxjs';
import { environment } from '../environments/environment';
import { HEC_CONSTANTS } from './utilities/constants';
// import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { catchError, map, tap } from 'rxjs/operators';
import { decrypt } from './utilities/utilityFunctions';
import { SharedService } from './shared/sharedServices/shared.service';




/** Pass untouched request through to the next request handler. */
@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  private isLoggingOut = false;
  
	constructor(private router: Router, private sharedService: SharedService ) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isLogoutCall = request.url.includes("logout");
		// const URL = "8089";
		const URL = "sc-v1";
		const requestURL = request.url;
		if (requestURL.includes(URL) && !requestURL.includes("authenticate")) {
			const access_token = localStorage.getItem(
				environment.JWT
			) as string;
			if (access_token) {
				request = request.clone({
					setHeaders: {
						Authorization: `Bearer ${access_token}`,
					},
				});
			}
			// return next.handle(request).pipe(
			// 	catchError<any, any>((err) => {
			// 		if (err instanceof HttpErrorResponse) {
			// 			if (err.status == 401 || err.status == 403) {
			// 				// this.redirectToLogin();
			// 				// this.sharedService.openConditionalErrors(
			// 				// 	"Your session has expired.",
			// 				// 	[
			// 				// 		"Please login again. Don't worry, we kept all your work saved",
			// 				// 	]
			// 				// );
			// 				return;
			// 			}
			// 			if (err.status == 500) {
			// 				// Show static error stub here.
			// 				// this.subjectService.appDataLoading.next({
			// 				// 	appDataLoading: false,
			// 				// });
			// 				// this.sharedService.showError(
			// 				// 	"Something went wrong. Please contact support for technical assisstance.",
			// 				// 	"OK",
			// 				// 	"error-snackbar"
			// 				// );
			// 				return;
			// 			}
			// 		}
			// 	})
			// );
      
			return next.handle(request).pipe(
				catchError((err: HttpErrorResponse) => {
				//   console.log("Interceptor error: ", err);
		  

        if (err.status === 401 && !this.isLoggingOut && !isLogoutCall) {
  
          console.log("1 Logout");
          
          this.isLoggingOut = true;
  
          this.sharedService.logoutUser().subscribe(
            () => this.isLoggingOut = false,
            () => this.isLoggingOut = false
          );
  
          localStorage.clear();
          localStorage.removeItem('esp-profile-details');
          this.router.navigate(['auth/login']);
        }
  
        return throwError(err);
				  // if (err.status === 401 || err.status === 403) {
					// // Optionally handle auth expiration here
				  // }
		  
				  // if (err.status === 500) {
					// Optionally handle server error here
				  // }
		  
				  // 👇 This line is important!
				  // return throwError(err); // ✅ return actual error object
				})
			  );
		}
		
		const currentUser = localStorage.getItem('esp-profile-details');
		let payload = JSON.parse(decrypt(localStorage.getItem('login')));
		let headers = new HttpHeaders();
		if (payload) {
			headers = headers.append('Authorization', 'Basic ' + btoa(payload['username'] + ":" + payload['password']));
			headers = headers.append("X-Requested-With", "XMLHttpRequest");
			let httpOptions = { headers: headers };
			if (currentUser) {
				request = request.clone({
					setHeaders: {
						'Content-Type': 'application/json',
					},
					headers: headers
				});

			}
		}
		else{
			if (currentUser) {
				request = request.clone({
					setHeaders: {
						'Content-Type': 'application/json',
					},
					 withCredentials: true
				});
			}
		}

		request = request.clone({
			withCredentials: true
		});

		return next.handle(request).pipe(tap(() => { },


			(err: any) => {

				if (err instanceof HttpErrorResponse) {
          console.log("2 Logout");
					if (err.status !== 401) {
						return;
					}
					this.router.navigate(['auth/login']);
					localStorage.removeItem('esp-profile-details')
					localStorage.clear()
				}
			}));
	}
}





// /** Pass untouched request through to the next request handler. */
// @Injectable()
// export class MyHttpInterceptor implements HttpInterceptor {

//   private isLoggingOut = false;

//   constructor(
//     private router: Router,
//     private sharedService: SharedService
//   ) {}

//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

//     const isLogoutCall = request.url.includes("logout");
//     const URL = "sc-v1";
//     const requestURL = request.url;
//     debugger
  
//     // Add token for protected API calls (sc-v1 only)
//     if (requestURL.includes(URL) && !requestURL.includes("authenticate")) {
//       const access_token = localStorage.getItem(environment.JWT) as string;
  
//       if (access_token) {
//         request = request.clone({
//           setHeaders: {
//             Authorization: `Bearer ${access_token}`,
//           },
//         });
//       }
//     }
  
//     // Basic Auth section
//     const currentUser = localStorage.getItem('esp-profile-details');
//     let payload = JSON.parse(decrypt(localStorage.getItem('login')));
//     let headers = new HttpHeaders();
  
//     if (payload) {
//       headers = headers.append('Authorization', 'Basic ' + btoa(payload['username'] + ":" + payload['password']));
//       headers = headers.append("X-Requested-With", "XMLHttpRequest");
  
//       if (currentUser) {
//         request = request.clone({
//           setHeaders: { 'Content-Type': 'application/json' },
//           headers: headers
//         });
//       }
  
//     } else {
//       if (currentUser) {
//         request = request.clone({
//           setHeaders: { 'Content-Type': 'application/json' },
//           withCredentials: true
//         });
//       }
//     }
  
//     request = request.clone({ withCredentials: true });
  
//     // ✅ Only ONE return call
//     return next.handle(request).pipe(
//       catchError((err: HttpErrorResponse) => {
  
//         if (err.status === 401 && !this.isLoggingOut && !isLogoutCall) {
  
//           this.isLoggingOut = true;
  
//           this.sharedService.logoutUser().subscribe(
//             () => this.isLoggingOut = false,
//             () => this.isLoggingOut = false
//           );
  
//           localStorage.clear();
//           localStorage.removeItem('esp-profile-details');
//           this.router.navigate(['auth/login']);
//         }
  
//         return throwError(err);
//       })
//     );
//   }
  
// }
